import React, { useState } from "react";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import MagnifyingGlassIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/MagnifyingGlassIconPath";
import { useToastNotification } from "@coworker/components/src/components/ToastNotification";
import { useTranslation } from "@coworker/locales";
import { ReplacedArticleListItem } from "../Molecules/ReplacedArticleListItem";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ExtractedArticleInformationType } from "@coworker/apprestructured/src/scan-and-search/types/ExtractedArticleInformationType";
import DefaultScannerComponentCameraControlled from "@coworker/apprestructured/src/scan-and-search/DefaultScannerComponentCameraControlled";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";

interface ReplaceProductProps {
  oldProductArticleIds: string[];
  numberBackup: number;
  alternativeBackupItemNo?: string;
  isSetAsBackupProduct?: boolean;
  alternativeBackUpProduct?: Item | undefined;
  handleItemChange?: (itemNo: string) => void;
}

export const ReplaceProduct = ({
  oldProductArticleIds,
  numberBackup,
  alternativeBackupItemNo,
  isSetAsBackupProduct = false,
  handleItemChange,
}: ReplaceProductProps) => {
  const { t } = useTranslation();
  const { showToast } = useToastNotification();

  const [shouldOpenSearchScreen, setShouldOpenSearchScreen] = useState(false);
  const [backupItemNo, setIsBackupItemNo] = useState(alternativeBackupItemNo);
  const handleItemSelection = async (
    itemInfo: ExtractedArticleInformationType
  ) => {
    setShouldOpenSearchScreen(false);
    const productNo = itemInfo.articleNumber;
    if (productNo) {
      if (oldProductArticleIds.includes(productNo)) {
        showToast(
          t("productAlreadyExistInRoomString"),
          undefined,
          undefined,
          5
        );
        setShouldOpenSearchScreen(false);
        return;
      }
      setIsBackupItemNo(productNo);
      handleItemChange?.(productNo);
    }
  };

  const title = isSetAsBackupProduct
    ? "setBackupArticleString"
    : "newProductString";
  return (
    <>
      <div onClick={() => setShouldOpenSearchScreen(true)}>
        <FixaListView id="replace-product-list" size={"small"}>
          <FixaListViewItem
            title={t(title)}
            leadingIcon={MagnifyingGlassIconPath}
            control={"navigational"}
            controlIcon={"chevronRightSmall"}
            emphasised
            inset
          />
        </FixaListView>
        {backupItemNo && (
          <ReplacedArticleListItem
            numberBackup={numberBackup}
            itemNo={backupItemNo || ""}
            isSetAsBackupProduct={isSetAsBackupProduct}
          />
        )}
      </div>
      <FixaModal
        visible={shouldOpenSearchScreen}
        handleCloseBtn={() => setShouldOpenSearchScreen(false)}
      >
        <FixaSheets
          header={
            <FixaModalHeader
              closeBtnClick={() => setShouldOpenSearchScreen(false)}
            />
          }
          footer={null}
          fullSize
        >
          <DefaultScannerComponentCameraControlled
            onResult={handleItemSelection}
            shouldHideSPRItems={false}
          />
        </FixaSheets>
      </FixaModal>
    </>
  );
};
